module.exports = __webpack_public_path__ + "static/img/img8.2baedca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img8.png
// module id = heLq
// module chunks = 0